export default class AccountOpening {
  constructor() {
    this.id = null;
    this.tradeAutomation = false;
    this.custodianId = null;
    this.repId = null;
    this.riaUserId = null;
    this.workflowId = null;
    this.featureStatus = false;
    this.linkAlias = '';
  }

  static make(mixObj) {
    const objAccountOpening = new AccountOpening();

    return Object.assign(objAccountOpening, mixObj);
  }
}
